module.exports = "/_next/static/images/idaho-3ffba499aaf5ffc303a1fc9c410994d2.svg";